
import { Component, Vue } from 'vue-property-decorator'
import ConsoleHeader from '@/components/ConsoleHeader.vue'

@Component({
  components: {
    ConsoleHeader,
  },
})
export default class App extends Vue {
  isMobile = false
  get isShowMenu() {
    return [
      'Home',
      'EditPassword',
      'Team',
      'Role',
      'OperationLog',
      'ModeSelect',
      'AccountDetail',
      'RegisterSuccess',
      'Certificate',
      'CertificateSuccess',
    ].includes(`${this.$route.name}`)
  }
  get isRegister() {
    return ['AccountDetail', 'RegisterSuccess', 'AuthorizeLogin', 'Authorize'].includes(`${this.$route.name}`)
  }
  handleResize() {
    const mobileWidth = 768
    this.isMobile = /Mobi|Android|iPhone/i.test(navigator.userAgent) ||
      (window.innerWidth || window.document.documentElement.clientWidth) <= mobileWidth
  }
  mounted() {
    this.handleResize()
    window.addEventListener('resize', this.handleResize)
  }
  beforeDestroy() {
    window.removeEventListener('resize', this.handleResize)
  }
}
